.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  font-family: var(--font-heading);
  font-weight: 500;
  letter-spacing: 1px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  transition: left 0.4s ease;
}

.button:hover::before {
  left: 100%;
}

/* Variants */
.primary {
  background: transparent;
  border: 1px solid var(--accent-cyan);
  color: var(--accent-cyan);
  box-shadow: 0 0 10px var(--glow-cyan), inset 0 0 10px var(--glow-cyan);
}

.primary:hover {
  background: var(--glow-cyan);
  color: var(--bg-primary);
  box-shadow: 0 0 20px var(--glow-cyan);
}

.primary:active {
  transform: scale(0.98);
}

.secondary {
  background: transparent;
  border: 1px solid var(--accent-magenta);
  color: var(--accent-magenta);
  box-shadow: 0 0 10px var(--glow-magenta);
}

.secondary:hover {
  background: var(--glow-magenta);
  color: var(--bg-primary);
}

.ghost {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-secondary);
}

.ghost:hover {
  border-color: var(--accent-cyan);
  color: var(--accent-cyan);
}

/* Sizes */
.sm {
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--text-xs);
}

.md {
  padding: var(--space-sm) var(--space-md);
  font-size: var(--text-sm);
}

.lg {
  padding: var(--space-md) var(--space-lg);
  font-size: var(--text-base);
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button:disabled:hover::before {
  display: none;
}
